module.exports = __webpack_public_path__ + "img/ksfd_icon.3179c6c4.png";